import React from 'react';

import { useFormatDate } from '../hooks/useFormatDate/useFormatDate';

type WithFormatDateProps = {
  formatDate: ReturnType<typeof useFormatDate>;
};

export function withFormatDate<P extends WithFormatDateProps>(
  WrappedComponent: React.ComponentType<P>,
) {
  const ComponentWithFormatDate = (
    props: Omit<P, keyof WithFormatDateProps>,
  ) => {
    const formatDate = useFormatDate();

    return <WrappedComponent {...(props as P)} formatDate={formatDate} />;
  };

  return ComponentWithFormatDate;
}
